import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { NumericInput } from '@makemydeal/dr-shared-components/numeric-input';
import * as baseDealSelectors from '@makemydeal/dr-dash-store/selectors/BaseDealSelectors';
import * as baseDealActionCreators from '@makemydeal/dr-dash-store/actions/baseDealActionCreators';
import { CANCELLATION_CHARGE_MAX } from '@makemydeal/dr-shared-ui-utils/validationConfigs/cancellationTermsValidationConfig';
import { featureToggleSelectors } from '@makemydeal/dr-shared-store';

type Props = {
    disabled?: boolean;
    hasError?: boolean;
    errorMessage?: string;
    onBlur?: (value: number | undefined) => void;
};

const CancellationChargeField = ({ disabled, hasError, errorMessage, onBlur }: Props) => {
    const dispatch = useDispatch();
    const storedValue = useSelector(baseDealSelectors.getRightToCancelCharge);
    const [inputText, setInputText] = useState<number | string>(storedValue ?? '');

    useEffect(() => {
        setInputText(storedValue ?? '');
    }, [storedValue]);

    const handleChange = (e: any) => {
        setInputText(e.target.value);
    };

    const handleBlur = () => {
        const raw = String(inputText).replace(/,/g, '').trim();
        const parsed = parseFloat(raw);
        const newValue = raw === '' || isNaN(parsed) ? undefined : parsed;
        const isInRange = newValue === undefined || (newValue >= 0 && newValue <= CANCELLATION_CHARGE_MAX);
        if (isInRange && newValue !== storedValue) {
            dispatch(baseDealActionCreators.updateRightToCancelCharge(newValue));
        }
        onBlur?.(newValue);
    };

    return (
        <NumericInput
            id="cancellation-charge"
            name="cancellation-charge"
            label="Cancellation Charge"
            value={inputText}
            onChange={handleChange}
            onBlur={handleBlur}
            disabled={disabled}
            hasError={hasError}
            errorMessage={errorMessage}
            data-testid="cancellation-charge"
            size="sm"
            allowDecimal
            decimalMaxLength={2}
            decimalMinLength={0}
            selectOnFocusSelector={featureToggleSelectors.isAutoSelectContentOnSlideOutsEnabledAfterBootstrap}
        />
    );
};

export default CancellationChargeField;
